// extracted by mini-css-extract-plugin
export default {"wrapper":"AddressPayment_wrapper__xihS1","info":"AddressPayment_info__inyCC"};